import Image from "next/image"

export default function ModalImage({
  imgSrc,
  height = 84,
  width = 84,
}: {
  imgSrc?: string
  height?: number
  width?: number
}) {
  return (
    <div className="flex justify-center mt-2">
      {imgSrc && (
        <Image
          src={imgSrc}
          alt="Blog logo"
          width={width}
          height={height}
          className="rounded-full"
        />
      )}
    </div>
  )
}
